import React from 'react'
import style from './header.module.scss'
import { Logo } from '../../logo/Logo'
import { VegaButton } from '../../vega/button/Button'
import { useTranslation } from 'react-i18next'
import { VegaSelectLang } from '../../vega/select/VegaSelectLang'
import cx from 'classnames'

/**
 * The animated header component of the payment tracker
 */
const Header = ({ isAnimate = true }) => {
	const { t } = useTranslation()

	return (
		<div
			className={cx(
				style.header,
				isAnimate && 'animate__animated',
				isAnimate && 'animate__fadeInDown'
			)}
		>
			<div className={style.container}>
				<div className={style.left}>
					<Logo />
				</div>
				<div className={style.right}>
					<VegaSelectLang className={style.languages} />
					<VegaButton
						className={style.button}
						label={t('headerOpenAccount')}
						onClick={() => window.open(t('headerOpenAccountHref'))}
					/>
				</div>
			</div>
		</div>
	)
}

Header.propTypes = {}

export { Header }
